import { SubmitReview } from "../../TYPES/api.body";
import { SUBMIT_REVIEW } from "../config/endpoints";
import api from "../config/setAuthHeader";

export const submitReview = async (formData: SubmitReview) => {
  return await api.post(SUBMIT_REVIEW, formData);
};
